import { createDate, importAll, transformImages } from "utils";

import AcceptanceLetterMain from "../../_hp-acceptance-letter-main";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <ReplicaQuote source="Harry Potter and the Philosopher's Stone">
        Harry picked it up and stared at it, his heart twanging like a giant
        elastic band. No one, ever, in his whole life, had written to him. Who
        would? He had no friends, no other relatives – he didn’t belong to the
        library so he’d never even got rude notes asking for books back. Yet
        here it was, a letter, addressed so plainly there could be no mistake:
        Mr H. Potter, The Cupboard under the Stairs, 4 Privet Drive, Little
        Whinging, Surrey
      </ReplicaQuote>

      <ReplicaParagraph>
        A fully readable, authentic replica of Harry Potter’s very first
        Hogwarts acceptance letter. Its arrival marks a pivotal turning point in
        his life - the moment the magical world first reached out to him.
        Addressed to "The Cupboard under the Stairs," it appears at the very
        beginning of Harry's story. Although this initial letter was swiftly
        confiscated before he even had the chance to open it, it triggered a
        relentless wave of letters that would find him no matter where the
        Dursleys tried to hide.
      </ReplicaParagraph>

      <AcceptanceLetterMain gallery={transformImages(gallery)} />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
